const writeReviewBtns = document.querySelectorAll('.write-review');
const seeReviewsBtn = document.querySelector(".see-all-reviews");
const modalContainer = document.querySelector(".modal-container");
const closeBtn = document.querySelector(".modal-container__inner__close-btn");
const yotpoStarsContainers = document.querySelectorAll(".yotpo.bottomLine");

export default function init ({ el, context }) {
  
  if(modalContainer){
    modalContainer.addEventListener('click', e => {
      if (e.target === modalContainer){
        hideModal()
      }
    })
  }

  writeReviewBtns.forEach( btn => {
    btn.addEventListener("click", () => {
      showModal()
    })
  })
   
  if(seeReviewsBtn){
    seeReviewsBtn.addEventListener('click', () => {
      showModal()
    })
  }

  if(closeBtn){
    closeBtn.addEventListener('click', () => {
      hideModal()
    })
  }

  document.addEventListener('keydown', press => {
    if (press.key === 'Escape' ){
      hideModal()
    }
  })

  function hideModal(){
    modalContainer.style.display = "none"
  }

  function showModal() {
    modalContainer.style.display = "block"
  }

  // function appendWriteReviewText() {
  //   console.log("it has run");
  //   // if (yotpoBtn.classList.length < 2) {
  //     // const reviewCount = yotpoBtn.getAttribute("aria-label");
  //     // console.log(reviewCount);
  //     let reviewText = yotpoBtn.getAttribute("aria-label");
  //     let reviewCount = parseInt( reviewText.slice(0,reviewText.indexOf(' review')) );
  //     yotpoBtn.innerHTML = `(${reviewCount}) Write a Review`; 
  //   // }
  // }

  window.addEventListener("load", () => {
    yotpoStarsContainers.forEach((starsAndText) => {
      starsAndText.addEventListener("click", () => {
        showModal();
      });
    });

    // setTimeout(appendWriteReviewText(), 2000);
  });
}